<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article v-if="getApplicantType === 'Ermunro'" class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center">ER MUNRO Professional Private <br> Investigators Insurance</h1>
          <h2 class="text-center">ER MUNRO Insurance Services, LLC <br />
              investigators@ermunro.org
              (888)-347-5273</h2>
        </article>

        <article v-else class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center">OREP Professional Private <br> Investigators Insurance</h1>
          <h2 class="text-center">OREP Insurance Services, LLC <br />
            investigators@orep.org
            (888)-347-5273</h2>
        </article>

        <article>
          <label for class="form-heading title-section form-section flex">
            <h1 class="form-title">General Application Information</h1>
          </label>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
              <span class="mr-1">1.</span>Business Name:
            </label>
            <input
              type="text"
              name="nameOfApplicant"
              v-model="ppiApplication.nameOfApplicant"
              class="orep-text-input w-100"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('nameOfApplicant')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Name of Principal Investigator:
          </label>
          <input
            type="text"
            name="contactName"
            v-model="ppiApplication.customer.contactName"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('contactName')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('contactName') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label ml-1">
                  Physical Street Address:
                </label>
                <input
                    type="text"
                    name="address"
                    v-model="ppiApplication.customer.address"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('address')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="city"
                    v-model="ppiApplication.customer.city"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('city')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 383px;"
                    name="state"
                    v-model="ppiApplication.customer.state"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                    v-show="errors.has('state')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCode"
                    v-model="ppiApplication.customer.zipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), zipCodeError = 'Please enter numeric values only') : (zipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="zipCodeError" class="text-danger small">{{ zipCodeError }}</span>
                <span
                    v-show="errors.has('zipCode')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>

            </div>
          </div>

        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="radio orep-radio-wrapper solo-checkbox" style="padding-bottom: 25px">
              <label class="orep-label ml-1">
                <input
                    type="checkbox"
                    name="checkIfMailAddressSame"
                    class="orep-radio w-40"
                    v-model="ppiApplication.checkIfMailAddressSame"
                >
                <span class="radio-span solo-checkbox-span" style="color: #046085">
                    Check this box if Mailing Address is the same
                  </span>
              </label>
            </div>
            <label v-if="!ppiApplication.checkIfMailAddressSame" for class="orep-label ml-1">
              Mailing Address:
            </label>
            <div v-if="!ppiApplication.checkIfMailAddressSame" class="row pb-3">
              <div class="col-md-12">
                <input
                    type="text"
                    name="mailingAddress"
                    v-model="ppiApplication.mailingAddress"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('mailingAddress')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingAddress') | filterText }}</span>
              </div>
            </div>
            <div v-if="!ppiApplication.checkIfMailAddressSame" class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="mailingCity"
                    v-model="ppiApplication.mailingCity"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('mailingCity')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingCity') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 383px;"
                    name="mailingState"
                    v-model="ppiApplication.mailingState"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                    v-show="errors.has('mailingState')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingState') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="mailingZipCode"
                    v-model="ppiApplication.mailingZipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), mailingZipCodeError = 'Please enter numeric values only') : (mailingZipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="mailingZipCodeError" class="text-danger small">{{ mailingZipCodeError }}</span>

                <span
                    v-show="errors.has('mailingZipCode')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingZipCode') | filterText }}</span>
              </div>

            </div>
          </div>
        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label">
                  <span class="mr-1"></span>Phone Number:
                </label>
                <input
                    type="text"
                    name="phone"
                    v-model="ppiApplication.customer.phone"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('phone')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label ml-1">
                  Email:
                </label>
                <input
                    type="email"
                    name="email"
                    v-model="ppiApplication.customer.email"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('email')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>
            </div>
          </div>

        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label">
                  <span class="mr-1"></span>Desired Effective Date:
                </label>
                <datepicker
                    name="effectiveDate"
                    v-model="ppiApplication.effectiveDate"
                    v-validate="'required'"
                    format="MM/dd/yyyy"
                    input-class="orep-text-input col-md-12"
                    @input="validateBeforeSubmit()"
                    :disabled="state.effectiveDateValid"
                    :clearButton="false"
                    :value="computedDates"
                ></datepicker>
                <span
                    v-show="errors.has('effectiveDate')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('effectiveDate') | filterText }}</span>
              </div>
            </div>
          </div>

        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label">
                  Website:
                </label>
                <input
                  type="text"
                  name="website"
                  v-model="ppiApplication.website"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('website')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('website') | filterText }}</span>
              </div>
              <div class="col-md-6">
                  <label for class="orep-label">
                    Date Business Established:
                  </label>

                <input
                  type="text"
                  name="dateEstablished"
                  v-model="ppiApplication.dateEstablished"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('dateEstablished')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('dateEstablished') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label">
                  Years of Experience:
                </label>

                <input
                    type="text"
                    name="yearsExperience"
                    v-model="ppiApplication.yearsExperience"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('yearsExperience')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('yearsExperience') | filterText }}</span>
              </div>
            </div>
          </div>      
        </article>
        <article>
          <label for class="form-heading title-section form-section flex">
            <h1 class="form-title">ABOUT YOUR INVESTIGATION FIRM</h1>
          </label>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            2. Your Services:
          </label>
          <div class="row operation-wrapper">
            <div class="item col-md-5">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="executiveProtection"
                      v-model="ppiApplication.executiveProtection"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Executive Protection (Low Profile)</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="backgroundInvestigations"
                      v-model="ppiApplication.backgroundInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Background Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="attorneyLegalInvestigations"
                      v-model="ppiApplication.attorneyLegalInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Attorney / Legal Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="arsonPropertyInvestigations"
                      v-model="ppiApplication.arsonPropertyInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Arson Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="computerForensic"
                      v-model="ppiApplication.computerForensic"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Digital Forensic / Cyber</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="accountingForensic"
                      v-model="ppiApplication.accountingForensic"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Accounting Forensic / AML</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="fidelityInvestigations"
                      v-model="ppiApplication.fidelityInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Domestic Investigations (Fidelity)</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="processServiceSubpoena"
                      v-model="ppiApplication.processServiceSubpoena"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Process Service / Subpoena</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="consulting"
                      v-model="ppiApplication.consulting"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Consulting</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="copyrightTrademarkInvestigations"
                      v-model="ppiApplication.copyrightTrademarkInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Copyright / Trademark Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="locateSkipTrace"
                      v-model="ppiApplication.locateSkipTrace"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Locate / SkipTrace</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="nflConsulting"
                    v-model="ppiApplication.nflConsulting"
                    class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% NFL Consulting</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="other"
                    v-model="ppiApplication.other"
                    class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Other (Write in Below)</label>
                </label>
              </div>
            </div>
            <div class="item col-md-5">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="debuggingTscm"
                    v-model="ppiApplication.debuggingTscm"
                    class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Debugging / TSCM</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="accidentReconstruction"
                      v-model="ppiApplication.accidentReconstruction"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Accident Reconstruction</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="number"
                    name="exitingInterview"
                    v-model="ppiApplication.exitingInterview"
                    class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                    @input="validateBeforeSubmit()"
                    style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Exiting Interview (Corporate)</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="surveillance"
                      v-model="ppiApplication.surveillance"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Surveillance</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="insuranceInvestigations"
                      v-model="ppiApplication.insuranceInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Insurance Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="fingerprintAnalysis"
                      v-model="ppiApplication.fingerprintAnalysis"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Fingerprint or Polygraph</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="firearmsTrainingClassRoom"
                      v-model="ppiApplication.firearmsTrainingClassRoom"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Firearms Training - Classroom Only</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="firearmsTrainingRange"
                      v-model="ppiApplication.firearmsTrainingRange"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Firearms Training - Range</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="genealogy"
                      v-model="ppiApplication.genealogy"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Genealogy</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="securityTraining"
                      v-model="ppiApplication.securityTraining"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Security Training</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="juvenileInvestigations"
                      v-model="ppiApplication.juvenileInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Juvenile Investigations</label>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                      type="number"
                      name="underCoverInvestigations"
                      v-model="ppiApplication.underCoverInvestigations"
                      class="orep-text-input mr-1"
                      oninput="this.value=(parseInt(this.value)||0)"
                      v-validate="'required|numeric'"
                      @input="validateBeforeSubmit()"
                      style="width: 75px"
                  >
                  <label class="mb-0 mr-1">% Infiltration/Undercover</label>
                </label>
              </div>
            </div>

            <div class="col-md-12 item">
              <input
              type="text"
              name="percentageOther"
              v-model="ppiApplication.percentageOther"
              class="orep-text-input w-100"
              @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('percentageOther')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('percentageOther') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
          <span>
            <i class="fas fa-exclamation-triangle not-eligible align-items-center"></i><span>NOTE: Security Guards, High Profile Bodyguards, Repossession Agents, Bounty Hunters, Claims Adjusters, Collection Agents, and Alarm installation and monitoring firms do not qualify for this Program. If you are active in these activities, Please Call: (888 347-5273)</span>
          </span>
          </label>
        </article>
      </form>
    </section>
    <section class="bottom-section">
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ppi-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ppi-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ppi-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid|| !state.pageThreeIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('ppi-application-5')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid|| !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('ppi-application-2')">Next</button>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "ppi-application-1",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    ppiApplication() {
      return this.$store.state.ppiApplication.ppiApplication;
    },
    state() {
      return this.$store.state.ppiApplication;
    },
    errorMsg() {
      return this.$store.state.ppiApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ppi-application-amba/' || this.ppiApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ppi-application-realshield/' || this.ppiApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }
      else if (first === '/ermunro/ppi-application/' || first === '/ERMUNRO/ppi-application/' || this.ppiApplication.customer.partnerName === 'Ermunro'){
        return 'Ermunro';
      }
      else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.ppiApplication.customer.contactName = this.state.ppiApplication.customer.contactName;
      this.ppiApplication.customer.companyName = this.state.ppiApplication.nameOfApplicant;
      this.ppiApplication.customer.isPpiApplication = 'True';
      this.ppiApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.ppiApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.ppiApplication.customer.partnerName = 'Realshield';
      }
      else if (this.getApplicantType === 'Ermunro'){
        this.ppiApplication.customer.partnerName = 'Ermunro';
      }
      this.$store.dispatch('ppiApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.ppiApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
/* Add CSS for mobile devices */
@media screen and (max-width: 480px) {
  .form-heading h1 {
    font-size: 24px; /* Adjust font size for mobile */
    line-height: 1.2; /* Adjust line height for mobile */
  }
  .form-heading h2 {
    font-size: 14px; /* Adjust font size for mobile */
    text-align: center; /* Center align the contact info */
  }
}

</style>
